import { useEffect, useRef } from 'react';

import { useAppPerformanceContext } from './AppPerformanceContext';
import { PerformanceTrackingConfig } from './AppPerformanceContext.types';

export * from './AppPerformanceContext';
export * from './AppPerformanceContext.types';

export const useTrackComponent = (
  componentName: string,
  config?: PerformanceTrackingConfig
) => {
  const { trackComponent } = useAppPerformanceContext();
  useEffect(() => {
    trackComponent(componentName, config);
  });
};

export const useTrackRenderTime = (componentName: string) => {
  const { trackRenderTime } = useAppPerformanceContext();
  const startTimeRef = useRef(performance.now());
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (!hasTrackedRef.current) {
      hasTrackedRef.current = true;
      requestAnimationFrame(() => {
        const renderDurationMs = performance.now() - startTimeRef.current;
        trackRenderTime(componentName, renderDurationMs);
      });
    }
  }, [componentName, trackRenderTime]);
};
